import React from "react"
import ReactDOM from "react-dom"
import ReactGA from "react-ga"
import "./font.css"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"

ReactGA.initialize(process.env.REACT_APP_TRACKING_ID)

ReactDOM.render(<App />, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
